export interface TocItem {
  id: string
  text: string
  level: number
  isMapSection?: boolean  // 是否是地图章节
}

export const useTableOfContents = () => {
  const headings = useState<TocItem[]>('toc-headings', () => [])
  const isMenuOpen = useState<boolean>('toc-menu-open', () => false)
  // 记录当前设置 headings 的路由路径，用于防止竞态条件
  const currentPath = useState<string>('toc-current-path', () => '')

  // 监听路由变化
  const route = useRoute()
  watch(() => route.fullPath, (newPath) => {
    // 路由变化时关闭菜单
    if (isMenuOpen.value) {
      isMenuOpen.value = false
    }
    // 路由变化时清空 headings（新页面会重新设置）
    // 这样可以避免旧组件 unmount 和新组件 mount 之间的竞态条件
    if (currentPath.value && currentPath.value !== newPath) {
      headings.value = []
    }
  })

  const setHeadings = (newHeadings: TocItem[]) => {
    headings.value = newHeadings
    // 记录是哪个路由设置的 headings
    currentPath.value = route.fullPath
  }

  const clearHeadings = () => {
    headings.value = []
    currentPath.value = ''
  }

  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
  }

  const closeMenu = () => {
    isMenuOpen.value = false
  }

  return {
    headings,
    isMenuOpen,
    setHeadings,
    clearHeadings,
    toggleMenu,
    closeMenu
  }
}
